module.exports = __webpack_public_path__ + "img/3ec34d51f0ff83c44926cb8fd716ebc6.png";